import React, { useState } from 'react';
import './changepass.css';

const ChangePass = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [retypePassword, setRetypePassword] = useState('');
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!password || !retypePassword) {
      setError('All fields are required');
      return;
    }

    if (password !== retypePassword) {
      setError('Passwords do not match');
      return;
    }

    setError('');
    setSuccess('');

    try {
      const token = localStorage.getItem('token'); // Get token
      if (!token) {
        setError('User not authenticated');
        return;
      }

      const response = await fetch(`${process.env.REACT_APP_SERVER_IP}/api/admin/updatepassword`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({ password }), // ✅ Only send password
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || 'Failed to update password');
      }
      alert('Password Updated successfully!');
      setSuccess(data.message || 'Password updated successfully');
    } catch (error) {
      setError(error.message);
    }
  };

  return (
    <div className="contain">
      <main className="main-content">
        <div className="form-containerOne">
          <form id="changePassForm" onSubmit={handleSubmit}>
            <h2 className='name'>Change Password</h2>
            <div className="form-group1">
              <input type="email" id="email" name="email" placeholder="E-mail" value={email} onChange={(e) => setEmail(e.target.value)} required />
            </div>

            <div className="form-group1">
              <input
                type="password"
                id="password"
                name="password"
                placeholder="Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
              />
            </div>
            <div className="form-group1">
              <input
                type="password"
                id="retype-password"
                name="retype-password"
                placeholder="Retype Password"
                value={retypePassword}
                onChange={(e) => setRetypePassword(e.target.value)}
                required
              />
            </div>
            {/* {error && <p className="error">{error}</p>}
            {success && <p className="success">{success}</p>} */}
            <button type="submit" className="update-detailsAdd">
              Update Password
            </button>
          </form>
        </div>
      </main>
    </div>
  );
};

export default ChangePass;
